/**
 * MediaRecorder format helpers for cross-browser voice recording.
 * Safari does NOT support WebM; it uses audio/mp4. Chrome/Firefox use audio/webm.
 * Use these so recording works on Safari as well as other browsers.
 */

const PREFERRED_MIMES = [
  'audio/webm',
  'audio/webm;codecs=opus',
  'audio/mp4',
  'audio/mp4;codecs=mp4a',
];

/**
 * Get the best MediaRecorder mime type supported by the current browser.
 * Safari typically only supports audio/mp4; Chrome/Firefox support audio/webm.
 * @returns {{ mimeType: string, extension: string }}
 */
export function getSupportedAudioRecorderFormat() {
  if (typeof window === 'undefined' || !window.MediaRecorder) {
    return { mimeType: 'audio/webm', extension: 'webm' };
  }
  for (const mime of PREFERRED_MIMES) {
    if (MediaRecorder.isTypeSupported(mime)) {
      const extension = mime.startsWith('audio/mp4') ? 'm4a' : 'webm';
      return { mimeType: mime, extension };
    }
  }
  // Fallback: use default (browser choice); assume mp4 for Safari-like behavior
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
    /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent);
  return {
    mimeType: isSafari ? 'audio/mp4' : 'audio/webm',
    extension: isSafari ? 'm4a' : 'webm',
  };
}
